export default __webpack_public_path__ + "static/media/Helvetica Neue LT 65 Medium.17567700.ttf";